import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: renders the list (index) or the $caseId detail via the Outlet.
// (Without this Outlet the detail route had nowhere to render and fell back to the list.)
export const Route = createFileRoute("/(app)/dashboard/audit-response")({
  component: () => <Outlet />,
});
